import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledMobileList = styled('div')`
  width: 100%;

  .ant-list-items {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .ant-pagination {
    display: flex;
    justify-content: space-evenly;
    align-items: center;

    .ant-pagination-item {
      min-width: 32px;
      height: 32px;
      line-height: 30px;
      margin: 0;
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    &.create-edit-product-list {
      .mobile-list-card-body-triple-section-wrapper {
        .mobile-list-card-body-triple-section-item {
          width: 33% !important;
          span {
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .mobile-list-card-body-triple-section-item:nth-child(even) {
          text-align: start !important;
          padding-left: 5px;
        }
        .mobile-list-card-body-triple-section-item:last-child {
          text-align: end !important;
          padding-right: 5px;
        }
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    &.create-edit-product-infrastructure-mobile-list {
      .ant-list-items {
        .mobile-list-card-body-wrapper {
          .mobile-list-card-body-item:first-child {
            width: 80%;
          }
          .mobile-list-card-body-item:nth-child(2) {
            width: 20%;
          }
        }
      }
    }
  }
`;
